import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import {
  checkoutGateEntryDetail,
  emptyCheckoutGateEntryDetail,
} from "src/app-redux/gate-entry/gateEntrySlice";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { useStyles } from "./style";

type Props = {
  vehicleDetails: any;
};

export default function GateOutDetails({ vehicleDetails }: Props): React.ReactElement {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const checkoutGateEntryDetailObj: any = useAppSelector(checkoutGateEntryDetail);
  const [scan, setScan] = useState<any[]>([]);
  const [weight, setWeight] = useState<any[]>([]);
  const [reciept, setReciept] = useState<any[]>([]);
  const [receiving, setReceiving] = useState<any[]>([]);
  const [weboc, setWeboc] = useState<any[]>([]);
  const [secondary, setSecondary] = useState<any[]>([]);

  useEffect(() => {
    return () => {
      dispatch(emptyCheckoutGateEntryDetail());
    };
  }, []);
  useEffect(() => {
    if (vehicleDetails) {
      setScan(vehicleDetails.scanComments ? vehicleDetails.scanComments.split("|^") : []);
      setWeight(vehicleDetails.weightComments ? vehicleDetails.weightComments.split("|^") : []);
      setReciept(
        vehicleDetails.commercialComments ? vehicleDetails.commercialComments.split("|^") : []
      );
      setReceiving(
        vehicleDetails.commercialPaymentReceivedComments
          ? vehicleDetails.commercialPaymentReceivedComments.split("|^")
          : []
      );
      setWeboc(vehicleDetails.weBocComments ? vehicleDetails.weBocComments.split("|^") : []);
      setSecondary(
        vehicleDetails.secondaryScanComments ? vehicleDetails.secondaryScanComments.split("|^") : []
      );
    }
  }, [vehicleDetails]);
  const getDays = (date: any) => {
    const eventDate = moment(date, "YYYYMMDD");
    const today = moment();
    const daysDiff = today.diff(eventDate, "days");
    return daysDiff;
  };
  return (
    <>
      {/* First Status */}
      <Grid item container spacing={4} style={{ marginTop: "0px" }}>
        <Grid item xs={12}>
          {/* <Typography className={classes.subDetails} style={{ textAlign: "center" }}>
            Details
          </Typography> */}

          <Grid container direction="row">
            <Grid item md={6} xs={12}>
              <Typography className={classes.subDetails}>GD Number:</Typography>
              <Typography variant="body2" className={classes.rightSubHeadings}>
                {checkoutGateEntryDetailObj && checkoutGateEntryDetailObj.gdNo
                  ? checkoutGateEntryDetailObj.gdNo
                  : "-"}
              </Typography>
            </Grid>

            <Grid item md={6} xs={12}>
              <Typography className={classes.subDetails}>Vehicle Type:</Typography>
              <Typography variant="body2" className={classes.rightSubHeadings}>
                {checkoutGateEntryDetailObj && checkoutGateEntryDetailObj.vehicleType
                  ? checkoutGateEntryDetailObj.vehicleType
                  : "-"}
              </Typography>
            </Grid>

            <Grid item md={6} xs={12}>
              <Typography className={classes.subDetails}>Type of Consignment:</Typography>
              <Typography variant="body2" className={classes.rightSubHeadings}>
                {checkoutGateEntryDetailObj && checkoutGateEntryDetailObj.consignmentTypeName
                  ? checkoutGateEntryDetailObj.consignmentTypeName
                  : "-"}
              </Typography>
            </Grid>

            <Grid item md={6} xs={12}>
              <Typography className={classes.subDetails}>Type of Cargo:</Typography>
              <Typography variant="body2" className={classes.rightSubHeadings}>
                {" "}
                {checkoutGateEntryDetailObj && checkoutGateEntryDetailObj.cargoTypeName
                  ? checkoutGateEntryDetailObj.cargoTypeName
                  : "-"}
              </Typography>
            </Grid>

            <Grid item md={6} xs={12}>
              <Typography className={classes.subDetails}>Total Payment Reveived:</Typography>
              <Typography variant="body2" className={classes.rightSubHeadings}>
                {" "}
                {checkoutGateEntryDetailObj && checkoutGateEntryDetailObj.totalPaymentReceived
                  ? ` Rs ${checkoutGateEntryDetailObj.totalPaymentReceived}`
                  : "-"}
              </Typography>
            </Grid>

            <Grid item md={6} xs={12}>
              <Typography className={classes.subDetails}>Weight:</Typography>
              <Typography variant="body2" className={classes.rightSubHeadings}>
                {" "}
                {checkoutGateEntryDetailObj && checkoutGateEntryDetailObj.totalWeight
                  ? `${checkoutGateEntryDetailObj.totalWeight} KG, ${moment(
                      checkoutGateEntryDetailObj?.weightTime
                    ).format("DD-MM-YYYY hh:mm a")}`
                  : "-"}
              </Typography>
            </Grid>

            <Grid item md={6} xs={12}>
              <Typography className={classes.subDetails}>Vehicle Entry Date/Time:</Typography>
              <Typography variant="body2" className={classes.rightSubHeadings}>
                {" "}
                {checkoutGateEntryDetailObj && checkoutGateEntryDetailObj.dateTime
                  ? moment(checkoutGateEntryDetailObj.dateTime).format("DD-MM-YYYY hh:mm a")
                  : "-"}
              </Typography>
            </Grid>

            <Grid item md={6} xs={12}>
              <Typography className={classes.subDetails}>Scan Date/Time:</Typography>
              <Typography variant="body2" className={classes.rightSubHeadings}>
                {" "}
                {checkoutGateEntryDetailObj && checkoutGateEntryDetailObj.scanTime
                  ? moment(checkoutGateEntryDetailObj.scanTime).format("DD-MM-YYYY hh:mm a")
                  : "-"}
              </Typography>
            </Grid>
            <Grid item md={6} xs={12}>
              <Typography className={classes.subDetails}>No of Day(s) Vehicle Stay:</Typography>
              <Typography variant="body2" className={classes.rightSubHeadings}>
                {checkoutGateEntryDetailObj && checkoutGateEntryDetailObj.dateTime
                  ? `${getDays(checkoutGateEntryDetailObj.dateTime)} Day(s)`
                  : "-"}
              </Typography>
            </Grid>
          </Grid>
          <Typography className={classes.subDetails} style={{ textAlign: "center" }}>
            Remarks
          </Typography>

          <Typography className={classes.subDetails}>Scan Inspector:</Typography>
          {vehicleDetails && vehicleDetails.scanComments
            ? scan.map((item: any, index: any) => (
                <Typography
                  variant="body2"
                  key={`scan-${index + 1}`}
                  className={classes.rightSubHeadings}
                >
                  {item}
                </Typography>
              ))
            : "-"}

          <Typography className={classes.subDetails}>Weight Inspector:</Typography>
          {vehicleDetails && vehicleDetails.weightComments
            ? weight.map((item: any, index: any) => (
                <Typography
                  variant="body2"
                  key={`weight-${index + 1}`}
                  className={classes.rightSubHeadings}
                >
                  {item}
                </Typography>
              ))
            : "-"}

          <Typography className={classes.subDetails}>Commercial Inspector (Receipt):</Typography>
          {vehicleDetails && vehicleDetails.commercialComments
            ? reciept.map((item: any, index: any) => (
                <Typography
                  variant="body2"
                  key={`reciept-${index + 1}`}
                  className={classes.rightSubHeadings}
                >
                  {item}
                </Typography>
              ))
            : "-"}

          <Typography className={classes.subDetails}>Commercial Inspector (Receiving):</Typography>
          {vehicleDetails && vehicleDetails.commercialPaymentReceivedComments
            ? receiving.map((item: any, index: any) => (
                <Typography
                  variant="body2"
                  key={`receiving-${index + 1}`}
                  className={classes.rightSubHeadings}
                >
                  {item}
                </Typography>
              ))
            : "-"}

          {/* <Typography className={classes.subDetails}>WeBOC Inspector:</Typography>
          {vehicleDetails && vehicleDetails.weBocComments
            ? weboc.map((item: any, index: any) => (
                <Typography
                  variant="body2"
                  key={`weboc-${index + 1}`}
                  className={classes.rightSubHeadings}
                >
                  {item}
                </Typography>
              ))
            : "-"} */}

          {/* <Typography className={classes.subDetails}>Secondary Scan Inspector:</Typography>
          {vehicleDetails && vehicleDetails.secondaryScanComments
            ? secondary.map((item: any, index: any) => (
                <Typography
                  variant="body2"
                  key={`secondary-${index + 1}`}
                  className={classes.rightSubHeadings}
                >
                  {item}
                </Typography>
              ))
            : "-"} */}
        </Grid>
      </Grid>
    </>
  );
}
